@defer(on timer(200ms)){
    <div class="h-screen flex items-center md:justify-center">
        <div class="text-center animate-pulse">
            <p class="md:mb-6 text-center w-full mt-4"><span class="text-6xl text-lrpTicketBlack font-extrabold md:me-5"><span class="tracking-widest text-lrpTicketBlue">LRP</span> Tickets</span><span class="hidden md:inline-block"> | The Portal To Adventure |</span></p>
            <p class="text-center w-full mb-10 md:hidden text-lrpTicketBlack text-2xl tracking-wider">| The Portal To Adventure |</p>
            <p class="italic">Please bear with us, we're just finding some things...</p>
            <p-carousel
                [value]="shuffledText" 
                [numVisible]="1" 
                [numScroll]="1" 
                [circular]="true" 
                [showNavigators]="false"
                [showIndicators]="false"
                autoplayInterval="3000">
                <ng-template let-text pTemplate="item">
                    <p class="italic text-xs">{{ text }}</p>
                </ng-template>
            </p-carousel>
        </div>   
    </div>
}